// src/utils/loadRazorpay.js
let razorpayLoadPromise = null;

export function loadRazorpayScript() {
  // Already loaded
  if (window.Razorpay) return Promise.resolve(true);

  // Already loading — return the same promise so we don't inject it twice
  if (razorpayLoadPromise) return razorpayLoadPromise;

  razorpayLoadPromise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => {
      razorpayLoadPromise = null; // allow retry on failure
      resolve(false);
    };
    document.body.appendChild(script);
  });

  return razorpayLoadPromise;
}